import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { ReactComponent as ManagementIcon } from '~/assets/management.svg';

export const Management = () => {
    const { t } = useTranslation();
    return (
        <Link
            to="/management"
            className="flex items-center px-2 py-1 gap-2 text-sm rounded transition-all"
            inactiveProps={{ className: 'text-white hover:bg-white hover:text-[#1e2b43]' }}
            activeProps={{ className: 'bg-white text-[#1e2b43]' }}
        >
            <>
                <ManagementIcon />
                <span>{t('TOP_HEADER.NAV_BAR.CRM_MANAGEMENT')}</span>
            </>
        </Link>
    );
};
